export { HighlightPlugin } from './editing';
